import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef, ComponentRef, ComponentFactory, TemplateRef, ViewChildren, QueryList, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/core/abstracts/base.component';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-modal',
  template: `
  <div class="modal fade" bsModal #modal="bs-modal"
     tabindex="-1" role="dialog" aria-labelledby="dialog-events-name"
     (onShow)="onModalShow()"
     (onShown)="onModalShown()"
     (onHide)="onModalHide()"
     (onHidden)="onModalHidden()">
    <div class="modal-dialog" [ngClass]="sizeClass != null ? sizeClass : ''">
      <div class="modal-content">
        <!-- <div class="modal-header">
          <h4 id="dialog-events-name" class="modal-title pull-left">Modal</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="modal.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div> -->
        <div class="modal-body">
          <button *ngIf="!this.forceChangePassword" 
            type="button" aria-label="Close" 
            class="close pull-right" (click)="closeModal();" 
            style="position: absolute; top: 30px; right: 40px; z-index: 999;">
            <span aria-hidden="true" style="font-size: 25px;">×</span>
          </button>
          <ng-content *ngIf="isContentVisible"></ng-content>
        </div>
      </div>
    </div>
  </div>
  `,
  styles: []
})
export class BaseModalComponent extends BaseComponent implements OnInit {

  forceChangePassword: boolean = false;
  
  isContentVisible: boolean = false;

  @ViewChild(ModalDirective, { static: false }) 
  modal: ModalDirective;

  @ViewChild('modalTemplate')
  public modalTemplate: TemplateRef<any>;

  @Input('backdropClick')
  closeOnBackdropClick: boolean = false;

  @Input('enableZooming')
  enableZooming: boolean = false;

  @Input('sizeClass')
  sizeClass: string = 'modal-lg';

  @Output('onShow')
  onShow: EventEmitter<void> = new EventEmitter()

  @Output('onShown')
  onShown: EventEmitter<void> = new EventEmitter()

  @Output('onHide')
  onHide: EventEmitter<void> = new EventEmitter()

  @Output('onHidden')
  onHidden: EventEmitter<void> = new EventEmitter()

  @Input('isVisible')
  isVisible: boolean = false;

  @Output('isVisibleChange')
  isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>()

  ngOnChanges(changes: SimpleChanges): void {

    if(changes.isVisible){

      if(changes.isVisible.currentValue){
        
        this.isContentVisible = true;
        this.modal.config = { class: this.sizeClass, ignoreBackdropClick: !this.closeOnBackdropClick, keyboard: false, backdrop: false, animated: true };
        this.modal.show();
        
      }
      else{
        this.closeModal()
      }

    }
    
  }

  ngOnInit() {
    this.forceChangePassword = this.authService.shouldForceChangePassword();
  }

  closeModal() {
    if (this.modal != null){
      this.modal.hide();
    }
  }
  
  screenZoomingOn() {
    this.metaService.updateTag({ name: 'viewport', content: 'width=device-width, initial-scale=1, user-scalable=yes' }, 'name="viewport"');
  }
  
  screenZoomingOff() {
    this.metaService.updateTag({ name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' }, 'name="viewport"');
  }

  onModalShow(){
    this.onShow.emit();
    if(this.enableZooming)
      this.screenZoomingOn();
  }

  onModalShown(){
    this.onShown.emit();
  }

  onModalHide(){
    this.onHide.emit();
    if(this.enableZooming)
      this.screenZoomingOff();
  }

  onModalHidden(){
    this.isVisible = false;
    this.isVisibleChange.emit(false);
    this.isContentVisible = false;
    this.onHidden.emit();
  }
  
}
